import React, { useEffect, useState, useRef } from "react";
import withAppState from "../mobx/withAppState";
import googlePayIcon from "../assets/img/icons/google-play-seeklogo.svg";
import applePayIcon from "../assets/img/icons/apple-store-seeklogo.svg";
import deliveryMan from '../assets/img/deliveryMan.svg';
import { Steps } from '../lib/constants';

const MenuFooter = ({
    brand,
    appPlatform,
    hasMarginTop,
    socialLinks,
    hasPEClub,
    children,
    setAppFooterHeight,
    restaurant,
    restaurantUrl,
    activeStep
}) => {
    const [year, setYear] = useState(null);
    const [footerLinks, setFooterLinks] = useState([]);
    useEffect(() => {
        var today = new Date();
        setYear(today.getFullYear());
    });
    

    useEffect(() => {
        let isMounted = true;
        async function fetchAPI() {
            try {
                const response = await fetch(`api/Menu/FooterLinks`);
                if (response.status === 200 && isMounted) {
                    const data = await response.json();
                    if (isMounted) {
                        setFooterLinks(data?.links);
                    }
                }
            } catch (error) {
                // Handle error if needed
            }
        }

        fetchAPI();
    }, []);  
    const appFooter = useRef();
    const googlePayLink =
        "https://play.google.com/store/apps/details?id=com.pizzaexpress.appv2";
    const applePayLink = "https://apps.apple.com/gb/app/pizzaexpress/id440565075";

    let bookATable = null;

    if(!!restaurant?.url && activeStep === Steps.PRE_ORDER){ //at the point when the user chooses or changes the restaurant

      bookATable = `https://www.milano.ie/${restaurant.url}/book/book-a-table`;
    }
    else if(!!restaurantUrl) //at the point when the digital menu loads from a local restaurant page in the milano main site
    {
        bookATable = `https://www.milano.ie/${restaurantUrl}/book/book-a-table`;
    }
  else { //at the point when the global menu loads.
      bookATable = "https://www.milano.ie/book/book-a-table-uk";
  }
    useEffect(() => {

        if (appFooter.current) {
            setAppFooterHeight(appFooter.current.clientHeight);
        }

        const updateWindowDimensions = () => {
            if (appFooter.current) {
                setAppFooterHeight(appFooter.current.clientHeight);
            }
        };

        window.addEventListener("resize", updateWindowDimensions);

        return () => window.removeEventListener("resize", updateWindowDimensions)

    }, [appFooter.current]);
    

    console.log(activeStep)

    return !!appPlatform ? null : (
        <footer
            ref={appFooter}
            className={`menu-footer ${!hasMarginTop ? "has-no-marginTop" : ""}`}
        >
            <div className="menu-footer-inner">
                {!!socialLinks && (
                    <>
                        <div className="menu-footer-section">
                            {socialLinks.map((social, i) => {
                                return (
                                    <div key={i} className="is-col">
                                        <a target="_blank" href={social.link}>
                                            <img
                                                className="footerIcon"
                                                src={require(`../assets/img/icons/${social.icon}.svg`)}
                                            />
                                        </a>
                                    </div>
                                );
                            })}
                        </div>
                        <hr className="menu-footer-divider" />

                    </>
                )}
                {!!hasPEClub && (
                    <>
                        <div className="menu-footer-section">
                            <div className="is-col">
                                <h5>PizzaExpress Club</h5>
                                <a
                                    href="https://www.pizzaexpress.com/create-an-account"
                                    className="is-row"
                                >
                                    Sign Up to My PizzaExpress
                                </a>
                                <div className="level">
                                    <a
                                        className="level-item is-shrinkable"
                                        target="_blank"
                                        href={googlePayLink}
                                    >
                                        <img src={googlePayIcon} />
                                    </a>
                                    <a
                                        className="level-item is-shrinkable"
                                        target="_blank"
                                        href={applePayLink}
                                    >
                                        <img src={applePayIcon} />
                                    </a>
                                </div>
                            </div>
                            <hr className="menu-footer-divider" />
                        </div>
                    </>
                )

                }
                {children}
                
                <div className={`menu-footer-section hide-mobile ${!!hasPEClub || !hasPEClub && 'pt-0'}`}>
                    <div className="is-col is-flex is-flex-col-mobile is-flex-row-desktop">
                        <p className="mb-1 pr-4">
                            <strong>© {brand} {year}</strong>
                        </p>
                        {!!footerLinks &&
                            footerLinks.map((footer, i) => {
                                return (
                                    <a className="pr-4" key={i} target="_blank" href={footer.url}>
                                        {footer.name}
                                    </a>
                                );
                            })}
                    </div>
                </div>
                <div className={`menu-footer-section footer-legal show-mobile is-row ${!!hasPEClub || !hasPEClub && 'pt-0'}`}>
                    <div className="is-col is-flex is-flex-col-mobile is-flex-row-desktop">
                        <p className="mb-1 pr-4">
                            <strong>© {brand} {year}</strong>
                        </p>
                        {!!footerLinks &&
                            footerLinks.map((footer, i) => {
                                return (
                                    <a className="pr-4" key={i} rel="noopener noreferrer" target="_blank" href={footer.url}>
                                        {footer.name}
                                    </a>
                                );
                            })}
                    </div>
                    <div>
                        <img alt="null" src={deliveryMan} />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default withAppState(MenuFooter, {
    mobXProps: ({ appPlatform, restaurant, restaurantUrl, activeStep }) => ({
        appPlatform,
        restaurant,
        restaurantUrl,
        activeStep
    }),
    mobXActions: ({
        setAppFooterHeight
    }) => ({
        setAppFooterHeight
    }),
});
